import { createContinuousLocationApiClient } from "../lib/apiClient";

const api = createContinuousLocationApiClient();

/**
 * Fetch the raw continuous-location points for a user between two timestamps.
 * Admin-only on the backend (varna-server checks user_group.group_name).
 *
 * Returns an array of points ordered by recorded_at ASC.
 */
export const fetchUserMovementPoints = async ({ queryKey }) => {
  const [, userId, from, to] = queryKey;
  if (!userId) return [];

  const params = { user_id: userId };
  if (from) params.from = from;
  if (to) params.to = to;

  const response = await api.get("/points", { params });
  // apiClient unwraps { data, meta } → response.data is the array directly.
  return Array.isArray(response.data) ? response.data : [];
};

/**
 * Fetch the user-level status row for the continuous sharing feature.
 * Useful to show "currently sharing" / last_point_at in the header.
 */
export const fetchContinuousLocationStatusForSelf = async () => {
  const response = await api.get("/status");
  return response.data;
};
